import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import MDTypography from "components/MDTypography";

const ConfirmDialog = ({
    open,
    title = "Confirm Action",
    description = "Are you sure you want to continue?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "primary",
    loading = false,
    onConfirm,
    onClose,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <MDTypography variant="body2">
                    {description}
                </MDTypography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    {cancelText}
                </Button>

                <Button
                    variant="contained"
                    disabled={loading}
                    onClick={onConfirm}
                    sx={{
                        backgroundColor: confirmColor === "success" ? "#2e7d32" :
                            confirmColor === "error" ? "#d32f2f" :
                                confirmColor === "warning" ? "#ed6c02" : "#1976d2",
                        color: "#ffffff",
                        borderRadius: 2,
                        "&:hover": {
                            backgroundColor: confirmColor === "success" ? "#1b5e20" :
                                confirmColor === "error" ? "#b71c1c" :
                                    confirmColor === "warning" ? "#e65100" : "#115293",
                        },
                        border: "1px solid",
                        borderColor: confirmColor === "success" ? "#2e7d32" :
                            confirmColor === "error" ? "#d32f2f" :
                                confirmColor === "warning" ? "#ed6c02" : "#1976d2",
                        minWidth: 140,
                        fontWeight: 600,
                    }}
                >
                    {confirmText}
                </Button>

            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
